/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_NameInputs */

const en_us2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club name`)
};

const pt_br2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do clube`)
};

const es_419_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del club`)
};

const pt_pt2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do clube`)
};

const fr_fr2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du club`)
};

const de_de2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Clubs`)
};

const it_it2_clubs_field_name = /** @type {(inputs: Clubs_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del club`)
};

/**
* | output |
* | --- |
* | "Club name" |
*
* @param {Clubs_Field_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_name = /** @type {((inputs?: Clubs_Field_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_name(inputs)
	if (locale === "es-419") return es_419_clubs_field_name(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_name(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_name(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_name(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_name(inputs)
	return en_us2_clubs_field_name(inputs)
});
export { clubs_field_name as "clubs.field_name" }